





















































































import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import AuthModule from '@/store/modules/Auth';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Statement from '@/components/Statement.vue';
import DepositWithdrawBody from '@/components/Table/DepositWithdrawBody.vue';
import Pagination from '@/components/Pagination.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Statement,
    Pagination,
    DepositWithdrawBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  StatementInstance = getModule(StatementModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  Criteria = {
    ...this.Period,
    role: this.AuthInstance.user.role,
    username: this.AuthInstance.user.username,
    limit: 100,
    page: 1,
    isSearch: false,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      role: this.AuthInstance.user.role,
    },
  ];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  StatementList: any = {};

  modal = false;

  dataList: any = [];

  LoginName = '';

  TableHead = DepositWithdrawData.TableHead;

  isAdmin = ['SUPERADMIN', 'ADMIN'].includes(this.AuthInstance.user.role);

  statementCriteria = {
    username: '',
    role: '',
  }

  currentDuration = 'Today'

  sum = {
    totalCreditDeposit: 0,
    deductCredit: 0,
    creditBalance: 0,
    totalAutoDeposit: 0,
    totalAutoWithdraw: 0,
    autoBalance: 0,
  };

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  created() {
    this.initial();
    this.fetchStatement();
  }

  initial() {
    this.Period = {
      start: {
        date: moment().startOf('day').toDate(),
      },
      end: {
        date: moment().endOf('day').toDate(),
      },
    };
    this.Criteria = {
      ...this.Period,
      role: this.AuthInstance.user.role,
      username: this.AuthInstance.user.username,
      // source: this.AuthInstance.user.source,
      isSearch: false,
      page: 1,
      limit: 100,
    };
    this.LoginName = '';
  }

  async fetchStatement() {
    if (this.currentTool !== this.currentDuration) {
      this.PaginationDetail.current = 1;
      this.Criteria.page = 1;
      this.currentDuration = this.currentTool;
    }
    const criteria = { ...this.Criteria, ...this.Period };
    this.GeneralInstance.toggleLoading(true);
    const res = await this.StatementInstance.FetchStatement(criteria);
    this.StatementList = this.StatementInstance.dataStatement;
    if (res.code) {
      this.checkError(res);
    } else {
      this.BreadcrumbList = [
        ...this.BreadcrumbDefault,
        ...this.StatementInstance.dataStatement.breadcrumb,
      ];
      this.dataList = this.StatementList.statements;
      this.sum = Object.assign(this.StatementList.footer);
      this.PaginationDetail.amount = this.StatementList.amountPage;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  openDetail(username, role) {
    this.modal = true;
    this.statementCriteria = {
      username,
      role,
    };
  }

  onSubmit() {
    this.fetchStatement();
  }

  onReset() {
    this.initial();
    this.fetchStatement();
  }

  handleSearch() {
    this.Criteria.isSearch = !!this.LoginName;
    this.Criteria.username = this.LoginName ? this.LoginName : this.AuthInstance.user.username;
  }

  handleFetcDepositWithdraw(username, role) {
    this.beforeFetch(username, role);
    this.fetchStatement();
  }

  handleBreadcrumb({ username, role }) {
    this.beforeFetch(username, role);
    this.fetchStatement();
  }

  beforeFetch(username, role) {
    this.Criteria.username = username;
    this.Criteria.role = role;
    // this.Criteria.source = source;
    this.Criteria.isSearch = false;
    this.LoginName = '';
    this.PaginationDetail.current = 1;
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    this.fetchStatement();
  }
}
